/*
 * Cascading Year / Make / Model vehicle selector, powered by CarAPI data.
 *
 * CarAPI blocks direct browser calls (CORS) and auth needs the secret, so the
 * dataset is pre-generated server-side into assets/carapi-vehicle-data.json
 * (years[], makes[], models{make:[...]}) and served statically. This script
 * wires any form's vehicle dropdowns to that data.
 *
 * Usage in a form:
 *   <script>window.GTU_VEHICLE_DATA_URL = "{{ 'carapi-vehicle-data.json' | asset_url }}";</script>
 *   <script src="{{ 'gtu-vehicle-select.js' | asset_url }}" defer></script>
 *   <div data-vehicle-select>
 *     <select data-vehicle-field="year">...</select>   (optional; left alone if already populated)
 *     <select data-vehicle-field="make"></select>
 *     <select data-vehicle-field="model" disabled></select>
 *   </div>
 * Model is year-independent (full list per make) — matches the CarAPI demo.
 */
(function () {
  var DATA_URL = window.GTU_VEHICLE_DATA_URL;
  if (!DATA_URL) return;

  var dataPromise = null;
  function getData() {
    if (!dataPromise) {
      dataPromise = fetch(DATA_URL)
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return dataPromise;
  }

  function option(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function fill(sel, items, placeholder) {
    var current = sel.value;
    sel.innerHTML = '';
    sel.appendChild(option('', placeholder || 'Select'));
    items.forEach(function (it) { sel.appendChild(option(it, it)); });
    if (current) sel.value = current; // preserve a pre-set value if still valid
  }

  function initGroup(group, data) {
    var yearSel = group.querySelector('[data-vehicle-field="year"]');
    var makeSel = group.querySelector('[data-vehicle-field="make"]');
    var modelSel = group.querySelector('[data-vehicle-field="model"]');

    // Year: only populate if it isn't already filled server-side.
    if (yearSel && yearSel.tagName === 'SELECT' && yearSel.options.length <= 1) {
      fill(yearSel, data.years.map(String), yearSel.getAttribute('data-placeholder') || 'Year');
    }

    if (makeSel) {
      fill(makeSel, data.makes, makeSel.getAttribute('data-placeholder') || 'Make');
    }

    function refreshModels() {
      if (!modelSel) return;
      var mk = makeSel ? makeSel.value : '';
      var models = (data.models && data.models[mk]) || [];
      fill(modelSel, models, modelSel.getAttribute('data-placeholder') || 'Model');
      modelSel.disabled = !mk || models.length === 0;
    }

    if (makeSel && modelSel) {
      makeSel.addEventListener('change', refreshModels);
      refreshModels();
    }
  }

  function init() {
    var groups = document.querySelectorAll('[data-vehicle-select]');
    if (!groups.length) return;
    getData().then(function (data) {
      if (!data) return;
      groups.forEach(function (g) { initGroup(g, data); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
